import { useQuery } from "@tanstack/react-query";

import { getDiaryIdForEntry, getInputUploadSignedUrl } from "@/features/inputs/api/getInputUploadSignedUrl";

interface UseInputUploadSignedUrlParams {
    diaryId?: string;
    entryId: string;
    inputId: string;
    fileName: string | null | undefined;
    objectId: string | null | undefined;
    enabled?: boolean;
}

export function useInputUploadSignedUrl({
    diaryId,
    entryId,
    inputId,
    fileName,
    objectId,
    enabled = true,
}: UseInputUploadSignedUrlParams) {
    const canFetch = enabled && Boolean(objectId && fileName && entryId && inputId);

    return useQuery({
        queryKey: ["input-upload-signed-url", diaryId, entryId, inputId, fileName, objectId],
        enabled: canFetch,
        queryFn: async () => {
            if (!fileName || !objectId) {
                throw new Error("Missing uploaded file reference.");
            }

            const resolvedDiaryId = diaryId ?? (await getDiaryIdForEntry(entryId));

            if (!resolvedDiaryId) {
                throw new Error("Could not resolve diary for this uploaded file.");
            }

            return getInputUploadSignedUrl({
                diaryId: resolvedDiaryId,
                entryId,
                inputId,
                fileName,
            });
        },
        staleTime: 60_000,
        retry: 1,
    });
}
